export function asMoneyString(x) {
  x = x || 0;
  if (typeof x === "string") {
    x = parseFloat(x.replace(/(!\d|!\.)/, ""));
  }
  const flooredX = Math.floor(Math.abs(x) * 100) / 100;
  const absoluteMoneyValue = flooredX.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimalRemoved = absoluteMoneyValue.split(".");
  return x >= 0 ? decimalRemoved[0] : "-" + decimalRemoved[0];
}

export function asNumberString(x) {
  x = x || 0;
  if (typeof x === "string") {
    x = parseFloat(x.replace(/(!\d|!\.)/, ""));
  }
  const flooredX = Math.floor(Math.abs(x) * 100) / 100;
  const absoluteNumberValue = flooredX.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (absoluteNumberValue.indexOf(".") > -1) {
    let val = absoluteNumberValue.split(".");
    return x >= 0 ? val[0] : "-" + val[0];
  }
  return x >= 0 ? absoluteNumberValue : "-" + absoluteNumberValue;
}

export function asPercentage(x) {
  const flooredX = (x * 100).toFixed(0);
  return flooredX;
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function asPercentageString(x) {
  x = x || 0;

  if (typeof x === "string") {
    x = parseFloat(x.replace(/(!\d|!\.)/, ""));
  }

  const flooredX = Math.floor(Math.abs(x) * 100) / 100;
  const absoluteNumberValue = flooredX.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (absoluteNumberValue.indexOf(".") > -1) {
    let val = absoluteNumberValue.split(".");
    return (x >= 0 ? val[0] : "-" + val[0]) + "%";
  }

  return (x >= 0 ? absoluteNumberValue : "-" + absoluteNumberValue) + "%";
}

export function asPercentageStringDecimal(x, toFixedValue) {
  x = x || 0;

  if (typeof x === "string") {
    x = parseFloat(x.replace(/(!\d|!\.)/, ""));
  }

  let val = x.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ",");

  if (typeof toFixedValue === "number") {
    val = parseFloat(val).toFixed(toFixedValue);
  }

  return (x >= 0 ? val : "-" + val) + "%";
}

export function formatPhoneNumber(s) {
  var s2 = ("" + s).replace(/\D/g, "");
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
}

export function calculateTableHeightBasedonNumberOfRows(rows, height) {
  if (rows < 2) {
    return rows * 85;
  } else if (rows > 10) {
    return height;
  } else {
    return rows * 50;
  }
}

export function formatCurrencySymbol(title, currencySymbol) {
  title = title || "";
  if (
    title.indexOf("visits") > 0 ||
    (title.indexOf("members") > 0 && !(title.indexOf("memberships") > 0)) ||
    title.indexOf("clients") > 0 ||
    title.indexOf("intros") > 0 ||
    title === "classes" ||
    title === "attendance"
  ) {
    return "";
  } else {
    return currencySymbol;
  }
}

export function formatClass(name) {
  name = name.replace(/\s+/g, "-").toLowerCase();
  return name;
}

export function getCheckedFilters(data) {
  let checked = [];
  data.map((data) => {
    if (data.checked) {
      checked.push({ id: data.id, name: data.name, checked: data.checked });
    }
  });
  return checked;
}

export function getCheckedFiltersIds(data) {
  let checked = [];
  data.map((data) => {
    if (data.checked) {
      checked.push(data.id);
    }
  });
  return checked;
}

export function forceChecked(data) {
  let list = [];
  data.map((item) => {
    list.push({
      id: item.id,
      name: item.name,
      checked: true
    });
  });
  return list;
}

export function getValueInsideTag(data) {
  let split1 = data.split(">");
  let split2 = split1[1].split("<");

  return parseInt(split2[0]);
}

export function stripHTMLTagsFromText(string, replacement = "") {
  return string.replace(/(<([^>]+)>)/gi, replacement);
}

export function SelectThanDeselectArray(arr1, arr2) {
  const arr2Ids = arr2.map((obj) => obj.id);
  const uniqueArr = arr1.filter((obj) => !arr2Ids.includes(obj.id));
  return uniqueArr.length > 0 ? uniqueArr : arr1;
}
export function isValidDateFormat(date) {
  //Checking for the following date types yyyy/mm/dd | dd/mm/yyy | yyyy-mm-dd | dd-mm-yyy
  const dateRegex =
    /^(?:\d{1,2}\/\d{1,2}\/\d{4}|\d{4}[/-]\d{1,2}[/-]\d{1,2}|\d{1,2}-\d{1,2}-\d{4})$/;

  return dateRegex.test(date);
}

export function convertTimeToTimestamp(timeStr) {
  if (!timeStr || typeof timeStr !== "string" || timeStr === "") return timeStr;

  timeStr = timeStr.trim();
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":");
  hours = parseInt(hours, 10);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  }
  if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);

  return date.getTime();
}

export function is12HourFormat(format) {
  return format === "HH:MM AM/PM" ? "hh:mm A" : "HH:mm";
}

export const formatMap = {
  "MM/DD/YYYY": "M/D/YYYY",
  "DD/MM/YYYY": "D/M/YYYY"
};
